/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TimeFrameDataInfo = {
    TFRMTP: TimeFrameDataInfo.TFRMTP;
    VAL: string;
};

export namespace TimeFrameDataInfo {

    export enum TFRMTP {
        VALUE = 'VALUE',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        HALF = 'HALF',
        YEAR = 'YEAR',
        YTD = 'YTD',
    }


}

